import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaTiktok, FaYoutube, FaPinterestP, FaGooglePlay , FaApple} from 'react-icons/fa';
import { SiFiverr } from 'react-icons/si';

const Footer = () => {
  const socialLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/aihairstylestudio/',
      icon: <FaFacebookF className="w-5 h-5" />,
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/aihairstylestudio',
      icon: <FaInstagram className="w-5 h-5" />,
    },
    {
      name: 'TikTok',
      url: 'https://www.tiktok.com/@aihairstylestudio',
      icon: <FaTiktok className="w-5 h-5" />,
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/@AIHairstyleStudio',
      icon: <FaYoutube className="w-5 h-5" />,
    },
    {
      name: 'Pinterest',
      url: 'https://uk.pinterest.com/aihairstylestudio/',
      icon: <FaPinterestP className="w-5 h-5" />,
    },
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
      <div className="max-w-7xl mx-auto py-10 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 md:gap-2">
          {/* Company Info */}
          <div className="pr-2">
            <h3 className="text-lg font-bold mb-3 text-teal-400">AI Hairstyle Studio</h3>
            <p className="text-gray-300 mb-3 text-sm">
              Transform your look with AI-powered hairstyle visualization
            </p>
            <ul>
              <li>
              <a 
              href="https://play.google.com/store/apps/details?id=com.devzam.makebald&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-1 bg-white text-black px-2 py-1 rounded-lg hover:bg-gray-100 transition-colors duration-200 mb-2"
            >
              <FaGooglePlay className="w-8 h-8 text-teal-500" />
              <div className="flex flex-col">
                <span className="text-xs">GET IT ON</span>
                <span className="text-xs font-semibold">Google Play</span>
              </div>
            </a>

              </li>
              <li>
            <a 
              href="https://apps.apple.com/us/app/bald-filter-ai-hairstyle/id6742877127"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-1 bg-white text-black px-2 py-1 rounded-lg hover:bg-gray-100 transition-colors duration-200"
            >
              <FaApple className="w-8 h-8 text-teal-500" />
              <div className="flex flex-col">
                <span className="text-xs">GET IT ON</span>
                <span className="text-xs font-semibold">Apple Play</span>
              </div>
            </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="px-2">
            <h3 className="text-lg font-bold mb-3 text-teal-400">Quick Links</h3>
            <ul className="space-y-1.5 text-sm">
              <li>
                <Link to="/try-on" className="text-gray-300 hover:text-teal-400 transition-colors duration-200">
                  Try New Hairstyle
                </Link>
              </li>
              <li>
                <Link to="/studio-hair-salon" className="text-gray-300 hover:text-teal-400 transition-colors duration-200">
                  Hairstyle Gallery
                </Link>
              </li>
              <li>
                <Link to="/hairstyles" className="text-gray-300 hover:text-teal-400 transition-colors duration-200">
                  Hairstyles
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-teal-400 transition-colors duration-200">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Reviews */}
          <div className="px-2">
            <h3 className="text-lg font-bold mb-3 text-teal-400">Upvote Us</h3>

            <div className="flex flex-col">
              <a href="/ai-hairstyle-reviews" target="_blank" rel="noopener noreferrer">
              <span className="text-s text-gray-300 hover:text-teal-400 transition-colors duration-200">
                  Feedback
                </span>
              </a>
            </div>
            
            <div className="flex flex-col">
              <a
                href="https://www.trustpilot.com/review/aihairstylestudio.com"
                target="_blank"
                rel="noopener noreferrer"
                className="group"
              >
                <div className="flex items-center mb-1">
                  <img
                    src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-4.svg"
                    alt="Trustpilot 3.9 stars"
                    className="h-3.5 w-auto"
                  />
                  <span className="ml-1 text-xs text-gray-300">3.9 out of 5</span>
                </div>
                <span className="text-xs text-gray-300 hover:text-teal-400 transition-colors duration-200">
                  Read our reviews on Trustpilot
                  <div className="flex items-center mb-1">
                  <img
                    src="/TrustPilot.png"
                    alt="Trustpilot 3.7 stars"
                    className="h-10 w-15"
                  />
                </div>
                </span>
              </a>
            </div>
                      <div className="flex items-center mb-1">
    <a 
        href="https://www.producthunt.com/posts/ai-hairstyle-3?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-ai-hairstyle-3" 
        target="_blank" 
        rel="noopener noreferrer"
    >
        <img  className='pb-2 mr-4 h-10 w-15'
            src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=842509&theme=dark&t=1739030865254" 
            alt="AI Hairstyle - Try on hairstyles with your picture for free | Product Hunt" 
        />
    </a>
</div>
          </div>

          {/* Legal */}
          <div className="px-2">
            <h3 className="text-lg font-bold mb-3 text-teal-400">Legal</h3>
            <ul className="space-y-1.5 text-sm">
              <li>
                <Link to="/legal/terms" className="text-gray-300 hover:text-teal-400 transition-colors duration-200">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/legal/privacy" className="text-gray-300 hover:text-teal-400 transition-colors duration-200">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/legal/cookies" className="text-gray-300 hover:text-teal-400 transition-colors duration-200">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/legal/disclaimer" className="text-gray-300 hover:text-teal-400 transition-colors duration-200">
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="px-2">
            <h3 className="text-lg font-bold mb-3 text-teal-400">Contact Us</h3>
            <ul className="space-y-1.5 text-sm">
              <li className="flex items-center space-x-2">
                <span>Email:</span>
                <a href="mailto:online@aihairstylestudio.com" className="hover:text-teal-400 transition-colors duration-200">
                online@aihairstylestudio.com
                </a>
              </li>
              <li>Phone: (+44) 07521967542</li>
              <li>
              <p className="text-gray-300">131 Raglan Rd, United Kingdom,<br />Birmingham, B66 3SR</p>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Media Links */}
        <div className="mt-4 border-t border-gray-800 pt-4">
          <div className="flex justify-center space-x-4">
            {socialLinks.map((item) => (
              <a
                key={item.name}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-teal-400 transition-colors duration-200"
                aria-label={item.name}
              >
                {item.icon}
              </a>
            ))}
          </div>
        </div>


         {/* Copyright Section */}
         <div className="mt-8 text-center">
          <div className="text-gray-400 text-sm">
            <p className="text-gray-500">
            ©️AIHairstyleStudio All rights reserved.
            </p>
          </div>
          <div className="mt-4 text-xs text-gray-600">
            <p className="mt-4 text-xs text-gray-600">
              AIHairstyleStudio is a registered trademark. Unauthorized use of any content, logo, or brand assets is strictly prohibited.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
